module.exports = __webpack_public_path__ + "img/wifi-off.877833a2.svg";